import URI from 'urijs';
import Utils from '../Utils';

class ConfigService {
  static contextApi = null;

  static getURL() {
    return this.urlConfig.api_url;
  }

  static getURLMedia() {
    return this.urlConfig.media_url;
  }

  static generateURL(endpoint, filters) {
      const url = `${this.getURL()}/${endpoint}`;
      const uri = new URI(url);
      uri.query(filters);

    return uri.toString();
  }

  static getColor(color, opacity, lighten) {
    let result = this.themeConfig[color];
    if (lighten){
      result = Utils.LightenDarkenColor(this.themeConfig[color], lighten);
    }
    if (opacity){
      let rgb = Utils.hexToRgb(result);
      return rgb ? 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b +', ' + opacity + ')' : null;
    }
    else {
      return result;
    }
  }

  static getDefaultColor(color, opacity) {
    if (opacity){
      let rgb = Utils.hexToRgb(this.themeDefaultConfig[color]);
      return rgb ? 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b +', ' + opacity + ')' : null;
    }
    else {
      return this.themeDefaultConfig[color];
    }
  }

  static getLogo(logo) {
    if (this.updated) {
      return this.logoConfig[logo];
    }
    else {
      return window.location.origin + this.logoConfig[logo];
    }
  };

  static updateConfig(configTeme) {
    this.urlConfig = configTeme.config.url_config;
    this.themeConfig = configTeme.config.theme_config;
    this.logoConfig = {
      logo1: configTeme.config.logo1,
      logo2: configTeme.config.logo2,
      logo3: configTeme.config.logo3,
    };
    this.updated = configTeme.updated;
  };

  static initContextApi(api) {
    this.contextApi = api;
  }

  static urlConfig = {};
  static logoConfig = {};

  static themeConfig = {
    primaryColor: '#36475F',
    secondaryColor: '#2895F1',
    tertiaryColor: '#A9B1BC',
    successColor: '#7ED321',
    warningColor: '#F5A623',
    errorColor: '#CE3B4D',
    auxColor: '#861B89',
  };

  static themeDefaultConfig = {
    primaryColor: '#36475F',
    secondaryColor: '#2895F1',
    tertiaryColor: '#A9B1BC',
    successColor: '#7ED321',
    warningColor: '#F5A623',
    errorColor: '#CE3B4D',
    auxColor: '#861B89',
  };
}

export default ConfigService;